import { useUIStore } from '../../store/ui';

export function EmptyState() {
  const setShow = useUIStore(s => s.setShowDealIndex);
  return (
    <div className="empty-state" style={{ paddingTop: 100 }}>
      <strong>No deal open</strong>
      <button
        className="btn-ghost"
        style={{ marginTop: 12, padding: '8px 14px', textTransform: 'none', letterSpacing: 0 }}
        onClick={() => setShow(true)}
      >
        Open a deal →
      </button>
    </div>
  );
}
